import { logUsage } from 'owa-analytics';
import { ClientItemId } from 'owa-client-ids';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import loc from 'owa-localize';
import { confirmDiscardChangesSubText } from 'owa-locstrings/lib/strings/confirmdiscardchangessubtext.locstring.json';
import { confirmDiscardChangesTitleText } from 'owa-locstrings/lib/strings/confirmdiscardchangestitletext.locstring.json';
import {
    closeNotesEditor,
    getNotesEditorViewState,
    NotesEditorViewState,
} from 'owa-calendar-notes-editor';

export default async function (itemId: ClientItemId, onConfirm: () => void) {
    const title = loc(confirmDiscardChangesTitleText);
    const subText = loc(confirmDiscardChangesSubText);
    const notesEditorViewState = getNotesEditorViewState(itemId);

    if (!notesEditorViewState) {
        // Notes editor wasn't open
        onConfirm();
        return;
    }

    if (
        !shouldShowConfirmationDialog(notesEditorViewState) ||
        (await confirm(title, subText, false, {
            // Wait until dialog is dismissed to avoid focus interruption
            delayCallbackAfterAnimation: true,
        })) === DialogResponse.ok
    ) {
        logUsage('NotesEditorDiscarded');
        closeNotesEditor(itemId);
        onConfirm();
    }
}

function shouldShowConfirmationDialog(notesEditorViewState: NotesEditorViewState): boolean {
    return notesEditorViewState.isDirty || notesEditorViewState.forwardees?.length > 0;
}
